const END_STAGE_NAMES = ['Hired', 'Rejected']

/** Nexus rejects a pipeline unless the locked Hired and Rejected stages are the last two. */
export function keepEndStagesLast<Stage extends { name: string; locked?: boolean | null }>(stages: Stage[]): Stage[] {
	const isEndStage = (stage: Stage) => !!stage.locked && END_STAGE_NAMES.includes(stage.name)

	return [...stages.filter((stage) => !isEndStage(stage)), ...stages.filter(isEndStage)]
}
